import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../context/ShopContext";
import Title from "../components/Title";
import { assets } from "../assets/assets";
import CartTotal from "../components/CartTotal";
import { Helmet } from "react-helmet";
import { FaTrash } from "react-icons/fa"; // Import the trash bin icon
import OurPolicycart from "../components/OurPolicycart";
import Testimonials from "../components/Testimonials";
import { FaLock } from "react-icons/fa";
import RelatedProducts from "../components/RelatedProducts";
import axios from "axios";
const Cart = () => {
   useEffect(() => {
      const backendUrl = import.meta.env.VITE_BACKEND_URL; // ✅ dynamic URL
      axios.post(`${backendUrl}/api/analytics/visit`, { page: "Cart" })
        .then(res => console.log("Cart visit recorded:", res.data))
        .catch(err => console.error("Analytics error:", err));
    }, []);
  const { products, currency, cartItems, updateQuantity, navigate } =
    useContext(ShopContext);

  const [cartData, setCartData] = useState([]);
  const [keywords, setKeywords] = useState("");

  useEffect(() => {
    if (products.length > 0) {
      const tempData = [];
      for (const itemId in cartItems) {
        for (const size in cartItems[itemId]) {
          for (const color in cartItems[itemId][size]) {
            if (cartItems[itemId][size][color] > 0) {
              tempData.push({
                _id: itemId,
                size: size,
                color: color,
                quantity: cartItems[itemId][size][color],
              });
            }
          }
        }
      }
      setCartData(tempData);

      // Generate keywords dynamically for SEO
      const cartKeywords = [
        ...new Set(
          tempData.map((item) => {
            const product = products.find(
              (product) => product._id === item._id
            );
            return product ? product.name : "";
          })
        ),
      ];

      setKeywords(cartKeywords.join(", "));
    }
  }, [cartItems, products]);

  return (
    <>
      <Helmet>
        <title>Your Cart</title>
        <meta
          name="description"
          content="Review the items in your cart before proceeding to checkout."
        />
        <meta name="keywords" content={keywords} />
      </Helmet>

      

      <div className="border-t pt-14 px-8 md:px-16 lg:px-20 mb-10">
        {/* Grid Layout for Cart Page */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Left Side: Cart Items */}
          <div>
            <h2 className="text-2xl sm:text-xl md:text-2xl mb-3 font-bold">
              My Cart ({cartData.length} items)
            </h2>

            <div className="space-y-6">
              {cartData.map((item, index) => {
                const productData = products.find(
                  (product) => product._id === item._id
                );

                const originalPrice = productData.originalPrice || productData.price * 1.2;
                const savings = (originalPrice - productData.price).toFixed(2);

                return (
                  <div
                    key={index}
                    className="py-6 px-8 border rounded-lg border-gray-900 text-gray-700 flex gap-8 relative flex-wrap sm:flex-nowrap"
                  >
                    {/* Product Image */}
                    <img
                      className="w-32 sm:w-40 md:w-48 h-[calc(40px*6)] sm:h-[calc(48px*6)] md:h-[calc(48px*6)] rounded-lg object-cover"
                      src={productData.image[0]}
                      alt={productData.name}
                    />

                    {/* Product Details */}
                    <div className="flex-1">
                      <p className="text-sm sm:text-base md:text-xl font-bold">{productData.name}</p>
                      <p className="text-xs sm:text-sm md:text-md text-gray-500 mt-3">{productData.category}</p>

                      <div className="flex items-center gap-3 mt-3">
                        <p className="text-xl sm:text-2xl md:text-2xl font-bold">
                          {currency}{productData.price}
                        </p>
                        <p className="text-xs sm:text-sm md:text-lg text-gray-400 line-through">
                          {currency}{originalPrice}
                        </p>
                      </div>
                      <p className="text-xs sm:text-sm md:text-md text-green-600 mt-3">
                        You are saving {currency}{savings} on this order
                      </p>

                      {/* Size & Quantity Selector */}
                      <div className="flex items-center gap-4 mt-4">
                        <p className="px-4 py-2 border bg-[#FF4902] text-white rounded-md text-xs sm:text-sm">
                          Size: {item.size}
                        </p>

                        <select
                          className="border w-24 px-2 py-2 text-center rounded-md bg-[#FF4902] text-white text-xs sm:text-sm"
                          value={item.quantity}
                          onChange={(e) =>
                            updateQuantity(item._id, item.size, item.color, Number(e.target.value))
                          }
                        >
                          {[...Array(11).keys()].slice(1).map((num) => (
                            <option key={num} value={num}>
                              {num}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* Trash Bin Icon for Removal */}
                    <button
                      onClick={() => updateQuantity(item._id, item.size, item.color, 0)}
                      className="absolute bottom-6 right-6 bg-[#FF4902] text-white p-2 rounded-full hover:bg-red-700"
                    >
                      <FaTrash size={20} />
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Side: Cart Total & Checkout */}
          <div className="flex flex-col items-center justify-start">
            <div className="w-full max-w-[450px] border p-6 rounded-lg shadow-md">
              <CartTotal />
              <button
                onClick={() => navigate("/place-order")}
                className="w-full bg-[#FF4902] text-white text-sm sm:text-md my-4 px-8 py-3 rounded-md"
              >
                PROCEED TO CHECKOUT
              </button>
            </div>
            <OurPolicycart className="w-[150px] h-[200px] sm:w-[400px] sm:h-[500px] mx-auto" />
          </div>
        </div>
      </div>
      <h1 className="text-center text-lg font-semibold flex items-center justify-center gap-2 mt-20">
        <FaLock /> 100% Secure Transaction
      </h1>
        <div className="flex flex-wrap justify-center items-center gap-6 mb-2 sm:mb-0">
          {[assets.flogo1, assets.flogo2, assets.flogo3, assets.flogo4, assets.flogo5, assets.flogo6].map((logo, index) => (
            <div key={index} className="bg-white rounded-md flex justify-center items-center p-4 shadow-md">
              <img src={logo} alt={`Partner Logo ${index + 1}`} className="h-16 w-auto" />
            </div>
          ))}
        </div>

        <RelatedProducts />

       <Testimonials/>
    </>
  );
};

export default Cart;
